import React, {useEffect} from 'react';
import '../styling/mainScreen.css';

const MainScreen = ({ setStep }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goToOutcomes = () => setStep('viewData');
  const goToSettings = () => setStep('settings');

  return (
    <div className="main-screen">
      <div className="panel">
        <div className="section">
          <div className="section-title"><span className="section-icon" aria-hidden>📊</span>Clinical Outcomes</div>
          <div className="row">
            <button className="pill success" onClick={() => setStep('submitData')}>
              <span className="icon" role="img" aria-label="success">✅</span>
              <span className="label">Success</span>
            </button>
            <button className="pill warning" onClick={() => setStep('complicationsMenu')}>
              <span className="icon" role="img" aria-label="complication">⚠️</span>
              <span className="label">Complication</span>
            </button>
            <button className="pill danger" onClick={() => setStep('emergencyPatientInfo')}>
              <span className="icon" role="img" aria-label="emergency">🚑</span>
              <span className="label">Emergency</span>
            </button>
          </div>
        </div>
        <div className="section">
          <div className="section-title"><span className="section-icon" aria-hidden>⚙️</span>Operations & Quality</div>
          <div className="row three">
            <button className="pill ops" onClick={() => setStep('operationsMenu')}>
              <span className="icon" role="img" aria-label="equipment">🧰</span>
              <span className="label">Equipment Malfunction</span>
            </button>
            <button className="pill ops" onClick={() => setStep('complaintsMenu')}>
              <span className="icon" role="img" aria-label="complaint">💬</span>
              <span className="label">Patient Complaint</span>
            </button>
            <button className="pill ops" onClick={() => setStep('schedulingMenu')}>
              <span className="icon" role="img" aria-label="scheduling">📅</span>
              <span className="label">Scheduling/Communication Error</span>
            </button>
          </div>
        </div>
        <div className="section">
          <div className="section-title"><span className="section-icon" aria-hidden>🛡️</span>Safety & Security</div>
          <div className="row single">
            <button className="pill purpleA" onClick={() => setStep('aggressivePatient')}>
              <span className="icon" role="img" aria-label="safety">🛡️</span>
              <span className="label">Aggressive Patient Interaction</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainScreen;